<div class="flex gap-2 align-items-center">
    <app-select-input
        [staticOptions]="$any(store.serviceTypes$ | async)"
        [form]="form"
        [id]="id"
        label="service.serviceType.label"
        [valueKey]="'id'"
        [filterBy]="'name'"
        [autoDisplayFirst]="true"
        [disabled]="disabled"
        style="width: 91%;">
        <ng-template #item let-data>
            {{ data.name }}
        </ng-template>
        <ng-template #selectedItem let-data>
            {{ data.name }}
        </ng-template>
    </app-select-input>
</div>
